import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuNewEventService extends BehaviorSubject<string[]> {
  constructor() {
    super(null);
  }
}
